import Cookies from "js-cookie";
import { createContext, useContext, useEffect, useState } from "react";
import { decrypt, key } from "../Utils/EncryptionDescryption";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  var ciphertext = Cookies.get(
    "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD"
  );
  var decryptredText = decrypt(ciphertext, key);
  // console.log(decryptredText)
  const [auth, setAuth] = useState({
    loginStatus:
      decryptredText.length > 1
        ? decryptredText[0][1] === "null"
          ? null
          : decryptredText[0][1]
        : null,
    role:
      decryptredText.length > 1
        ? decryptredText[1][1] === "null"
          ? null
          : decryptredText[1][1]
        : null,
    user_id:
      decryptredText.length > 1
        ? decryptredText[2][1] === "null"
          ? null
          : decryptredText[2][1]
        : null,
    email:
      decryptredText.length > 1
        ? decryptredText[3][1] === "null"
          ? null
          : decryptredText[3][1]
        : null,
    mobile_number:
      decryptredText.length > 1
        ? decryptredText[4][1] === "null"
          ? null
          : decryptredText[4][1]
        : null,
    user_name:
      decryptredText.length > 1
        ? decryptredText[5][1] === "null"
          ? null
          : decryptredText[5][1]
        : null,
    vpbx_id:
      decryptredText.length > 1
        ? decryptredText[5][1] === "null"
          ? null
          : decryptredText[6][1]
        : null,
    company_name:
      decryptredText.length > 1
        ? decryptredText[7][1] === "null"
          ? null
          : decryptredText[7][1]
        : null,
    address:
      decryptredText.length > 1
        ? decryptredText[8][1] === "null"
          ? null
          : decryptredText[8][1]
        : null,
    ntn:
      decryptredText.length > 1
        ? decryptredText[9][1] === "null"
          ? null
          : decryptredText[9][1]
        : null,
    work_number:
      decryptredText.length > 1
        ? decryptredText[10][1] === "null"
          ? null
          : decryptredText[10][1]
        : null,
    password:
      decryptredText.length > 1
        ? decryptredText[11][1] === "null"
          ? null
          : decryptredText[11][1]
        : null,
    diodid:
      decryptredText.length > 1
        ? decryptredText[12][1] === "null"
          ? null
          : decryptredText[12][1]
        : null,
    template_name:
      decryptredText.length > 1
        ? decryptredText[13][1] === "null"
          ? null
          : decryptredText[13][1]
        : null,
    package_id:
      decryptredText.length > 1
        ? decryptredText[14][1] === "null"
          ? null
          : decryptredText[14][1]
        : null,
    package_activation_datetime:
      decryptredText.length > 1
        ? decryptredText[15][1] === "null"
          ? null
          : decryptredText[15][1]
        : null,
    // +
    // ":" +
    // decryptredText[15][2] +
    // ":" +
    // decryptredText[15][3]: null,
    package_inactivation_datetime:
      decryptredText.length > 1
        ? decryptredText[16][1] === "null"
          ? null
          : decryptredText[16][1]
        : null,
    bolt_on_id:
      decryptredText.length > 1
        ? decryptredText[17][1] === "null"
          ? null
          : decryptredText[17][1]
        : null,
    bolt_on_activation_datetime:
      decryptredText.length > 1
        ? decryptredText[18][1] === "null"
          ? null
          : decryptredText[18][1]
        : null,
    bolt_on_inactivation_datetime:
      decryptredText.length > 1
        ? decryptredText[19][1] === "null"
          ? null
          : decryptredText[19][1]
        : null,
    bundle_id:
      decryptredText.length > 1
        ? decryptredText[20][1] === "null"
          ? null
          : decryptredText[20][1]
        : null,
    bundle_datetime:
      decryptredText.length > 1
        ? decryptredText[21][1] === "null"
          ? null
          : decryptredText[21][1]
        : null,
    inbound_recording:
      decryptredText.length > 1
        ? decryptredText[22][1] === "null"
          ? null
          : decryptredText[22][1]
        : null,
    outbound_recording:
      decryptredText.length > 1
        ? decryptredText[23][1] === "null"
          ? null
          : decryptredText[23][1]
        : null,
    extension_recording:
      decryptredText.length > 1
        ? decryptredText[24][1] === "null"
          ? null
          : decryptredText[24][1]
        : null,
    bundle_inactivation_datetime:
      decryptredText.length > 1
        ? decryptredText[25][1] === "null"
          ? null
          : decryptredText[25][1]
        : null,
    status:
      decryptredText.length > 1
        ? decryptredText[26][1] === "null"
          ? null
          : decryptredText[26][1]
        : null,
    created_on:
      decryptredText.length > 1
        ? decryptredText[27][1] === "null"
          ? null
          : decryptredText[27][1]
        : null,
    updated_on:
      decryptredText.length > 1
        ? decryptredText[28][1] === "null"
          ? null
          : decryptredText[28][1]
        : null,
    id:
      decryptredText.length > 1
        ? decryptredText[29][1] === "null"
          ? null
          : decryptredText[29][1]
        : null,
    name:
      decryptredText.length > 1
        ? decryptredText[30][1] === "null"
          ? null
          : decryptredText[30][1]
        : null,
    defaultuser:
      decryptredText.length > 1
        ? decryptredText[31][1] === "null"
          ? null
          : decryptredText[31][1]
        : null,
    extension_number:
      decryptredText.length > 1
        ? decryptredText[32][1] === "null"
          ? null
          : decryptredText[32][1]
        : null,
    email_id:
      decryptredText.length > 1
        ? decryptredText[33][1] === "null"
          ? null
          : decryptredText[33][1]
        : null,
    extension_name:
      decryptredText.length > 1
        ? decryptredText[34][1] === "null"
          ? null
          : decryptredText[34][1]
        : null,
    token:
      decryptredText.length > 1
        ? decryptredText[35][1] === "null"
          ? null
          : decryptredText[35][1]
        : null,
    is_templete:
      decryptredText.length > 1
        ? decryptredText[36][1] === "null"
          ? null
          : decryptredText[36][1]
        : null,
    is_feedback:
      decryptredText.length > 1
        ? decryptredText[37][1] === "null"
          ? null
          : decryptredText[37][1]
        : null,
    call_initiated:
      decryptredText.length > 1
        ? decryptredText[38][1] === "null"
          ? null
          : decryptredText[38][1]
        : null,
    oc_status:
      decryptredText.length > 1
        ? decryptredText[39][1] === "null"
          ? null
          : decryptredText[39][1]
        : null,
  });
  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used within a AuthProvider");
  }

  return context;
};

export { AuthProvider, useAuth };
